// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom_renderer > div {\n  display: flex;\n  align-items: center;\n}\n.custom_renderer .rg-renderer:hover .custom-hover {\n  visibility: visible;\n}\n.custom_renderer .rg-renderer .custom-hover {\n  visibility: visible;\n}\n.custom_renderer .rg-renderer .custom-focused {\n  visibility: visible;\n}\n\n", ""]);
// Exports
module.exports = exports;
